<template>
    <div class="form-horizontal">
        <div class="form-group">
            <label for="user-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.type') }}*</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="user-options" v-model="rate.type">
                    <option v-for="rateType in rateTypeOptions" :key="rateType.value"
                            :value="rateType.value">{{rateType.name}}</option>
                </select>
            </div>
        </div>
        <div class="form-group">
            <label for="rate_name" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.name') }}*</label>
            <div class="col-xs-12 col-md-8">
                <input v-model="rate.name" class="form-control" type="text" id="rate_name" name="rate_name" :placeholder="$t('components.rate.ex_name')">
            </div>
        </div>
        <div class="form-group">
            <label for="rate_duration" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.duration') }}*</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="rate_duration" name="rate_duration" placeholder="60" v-model="rate.duration_in_minutes">
                    <div class="input-group-addon">{{ $t('unit.minute') }}</div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="rate_max_participant" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.max_participant') }}*</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="rate_max_participant" placeholder="8" name="rate_max_participant" v-model="rate.max_participant">
                    <div class="input-group-addon">{{ $t('unit.person') }}</div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="rate_max_participant_online" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.max_participant_online') }}</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="rate_max_participant_online" placeholder="30" name="rate_max_participant_online" min="2" max="100" v-model="rate.max_participant_online">
                    <div class="input-group-addon">{{ $t('unit.person') }}</div>
                </div>
            </div>
        </div>
        <div class="form-group" v-if="isCourseType">
            <label for="rate_appointment_count" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.how_may_appointments') }}*</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="rate_appointment_count" placeholder="4" name="rate_appointment_count" v-model="rate.appointment_count">
                    <div class="input-group-addon">{{ $t('unit.appointment') }}</div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="rate_price" class="col-xs-12 col-md-4 control-label">{{ $t('common.price') }}*</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="rate_price" name="rate_price" v-model="rate.price" placeholder="0,00" step="0.01">
                    <div class="input-group-addon">{{default_currency}}</div>
                </div>
                <div v-if="rate.price">
                    <p class="help-block">{{ $t('components.rate.gross_price', {gross_price: grossPrice, gross_price_currency: getCurrencySymbolFromString(rate.price_currency)}) }}</p>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="rate_price_online" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.price_online') }}</label>
            <div class="col-xs-12 col-md-8">
                <div class="input-group" style="width:200px;">
                    <input class="form-control" type="number" id="rate_price_online" name="rate_price_online" v-model="rate.price_online" placeholder="0,00" step="0.01">
                    <div class="input-group-addon">{{default_currency}}</div>
                </div>
                <div v-if="rate.price_online">
                    <p class="help-block">{{ $t('components.rate.gross_price', {gross_price: grossPriceOnline, gross_price_currency: getCurrencySymbolFromString(rate.price_online_currency)}) }}</p>
                </div>
            </div>
        </div>

        <div class="form-group" v-if="subscriptionChoice && rate.type !== RATE_TYPE.COURSE">
            <label for="rate_price_online" class="col-xs-12 col-md-4 control-label">{{ $t('components.rate.subscription_choice') }}</label>
            <div class="col-xs-12 col-md-8">
                <VmCollapse>
                    <VmCollapseItem :title="$t('subscription_category.normal')" v-if="normalSubscriptionTypeAvailable.length > 0">
                        <table @click.stop="" class="table table-condensed">
                            <tbody>
                            <tr v-for="(subscription_type, index) in normalSubscriptionTypeAvailable" v-bind:key="index">
                                <td>
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox" :value="subscription_type.id" v-model="subscription_type_valid">
                                            {{subscription_type.name}}
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </VmCollapseItem>
                    <VmCollapseItem :title="$t('subscription_category.carnet')"  v-if="carnetSubscriptionTypeAvailable.length > 0">
                        <table @click.stop="" class="table table-condensed">
                            <tbody>
                            <tr v-for="(subscription_type, index) in carnetSubscriptionTypeAvailable" v-bind:key="index">
                                <td>
                                    <div class="checkbox">
                                        <label>
                                            <input type="checkbox" :value="subscription_type.id" v-model="subscription_type_valid">
                                            {{subscription_type.name}}
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </VmCollapseItem>
                </VmCollapse>


            </div>
        </div>
    </div>
</template>

<script>
    import {RATE_TYPE, RATE_TYPE_OPTIONS, SUBSCRIPTION_CATEGORY} from "../../common/constants";
    import {Utils} from "../../common/utils";
    import {getAllSubscriptionsType} from "../../api";
    import {VmCollapse, VmCollapseItem} from 'vue-multiple-collapse'


    export default {
        components: {VmCollapse, VmCollapseItem},
        name: "RateForm",
        props: {
            rateProp: {
                type: Object,
                required: true
            },
            subscriptionChoice: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency)
            }
        },
        data: () => {
            return {
                RATE_TYPE: RATE_TYPE,
                rateTypeOptions: RATE_TYPE_OPTIONS(),
                rate: {
                    id: null,
                    name: null,
                    type: null,
                    duration_in_minutes: null,
                    max_participant: null,
                    max_participant_online: null,
                    price: null,
                    price_currency: null,
                    appointment_count: null,
                    subscription_type_valid: [],
                },
                subscription_type_valid: [],
                subscriptionTypeAvailable: [],
                normalSubscriptionTypeAvailable: [],
                carnetSubscriptionTypeAvailable: [],
                default_currency: ""
            }
        },
        computed: {
            isCourseType: function () {
                return this.rate.type === RATE_TYPE.COURSE
            },
            grossPrice() {
                return Utils.getGrossPriceOnlineWithCreditCard(this.rate.price)
            },
            grossPriceOnline() {
                return Utils.getGrossPriceOnlineWithCreditCard(this.rate.price_online)
            }
        },
        mounted: async function () {
            this.rate = this.rateProp;
            this.default_currency = Utils.getCompanyCurrency();
            this.subscriptionTypeAvailable = await getAllSubscriptionsType();
        },
        watch: {
            rateProp: function(newVal) {
                this.rate = newVal;
            },
            subscription_type_valid: {
                handler(newVal) {
                    this.rate.subscription_type_valid = newVal;
                    this.$emit('change', this.rate);
                },
                deep: true,
            },
            rate: {
                handler(newVal) {
                    this.$emit('change', newVal)
                },
                deep: true,
            },

            subscriptionTypeAvailable: function(newVal) {
                console.log(newVal);

                this.normalSubscriptionTypeAvailable = this.subscriptionTypeAvailable.filter(function(item) {
                    return item.category === SUBSCRIPTION_CATEGORY.NORMAL
                });

                this.carnetSubscriptionTypeAvailable = this.subscriptionTypeAvailable.filter(function(item) {
                    return item.category === SUBSCRIPTION_CATEGORY.CARNET
                });
            }
        }
    }
</script>
